// constants/menu.js
import dayjs from 'dayjs';

const PRICE_TIERS = [
    { from: '2026-06-01', price: 9.00 },
    { from: '2025-05-21', price: 8.50 },
];

export const getDefaultMealPrice = (date) =>
    PRICE_TIERS.find(tier => !dayjs(date).isBefore(tier.from))?.price ?? 8.00;
